import { observer } from "mobx-react-lite";
import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { useVideoStore } from "../../../../shared/hooks/useVideoStore";
import { VideoPlayer } from "./components/VideoPlayer";
import { Context } from "./components/Context";
import {
    CloseSC,
    ContentSC,
    ContextWrapperSC,
    PortalSC,
    VideoWrapperSC,
} from "./styled";

const modalRoot = document.getElementById("root");

export const VideoModal = observer(() => {
    const videoStore = useVideoStore();
    const overlayRef = useRef<HTMLDivElement>(null);

    if (!videoStore.isModalOpen || !modalRoot) return null;

    const handleOverlayMouseLeave = () => {
        // videoStore.closeModal();
    };

    // useEffect(() => {
    //     const handleClick = (e: MouseEvent) => {
    //         if (
    //             overlayRef.current &&
    //             !overlayRef.current.contains(e.target as Node)
    //         ) {
    //             videoStore.hideContextMenu();
    //         }
    //     };
    //
    //     const handleKeyDown = (e: KeyboardEvent) => {
    //         switch (e.key) {
    //             case "Escape":
    //                 videoStore.closeModal();
    //                 break;
    //             case " ":
    //                 e.preventDefault();
    //                 videoStore.setPlaying(!videoStore.isPlaying);
    //                 break;
    //             case "ArrowLeft":
    //                 e.preventDefault();
    //                 videoStore.seekBySeconds(-5);
    //                 break;
    //             case "ArrowRight":
    //                 e.preventDefault();
    //                 videoStore.seekBySeconds(5);
    //                 break;
    //         }
    //     };
    //
    //     // document.addEventListener("click", handleClick);
    //     // document.addEventListener("keydown", handleKeyDown);
    //
    //     return () => {
    //         // document.removeEventListener("click", handleClick);
    //         // document.removeEventListener("keydown", handleKeyDown);
    //     };
    // }, [videoStore]);

    return ReactDOM.createPortal(
        <PortalSC
            onMouseLeave={handleOverlayMouseLeave}
            role="dialog"
            aria-modal="true"
            aria-label="Video player overlay"
        >
            <CloseSC
                onClick={() => videoStore.closeModal()}
                aria-label="Close video player"
            >
                ×
            </CloseSC>
            <ContentSC>
                <VideoWrapperSC ref={overlayRef}>
                    <VideoPlayer />
                </VideoWrapperSC>
                <ContextWrapperSC>
                    <Context />
                </ContextWrapperSC>
            </ContentSC>
        </PortalSC>,
        modalRoot,
    );
});
